import { BarChart,Bar, CartesianGrid, Line, LineChart, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend } from 'recharts';


import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../Components/Cards";


const formatValue = (value: number, format?: "DOLLARS" | "PERCENTAGES" | "NUMBER") => {
  let pValue = value.toString();

  if(value >= 1000 && value < 1_000_000){
    pValue = (value / 1000) + 'K';
  }else if(value >= 1_000_000 && value < 1_000_000_000){
    pValue = (value / 1_000_000) + 'M';
  }else if(value >= 1_000_000_000){
    pValue = (value / 1_000_000_000) + 'B';
  } else if (value >= 1_000_000_000 && value < 1_000_000_000_000){
    pValue = (value / 1_000_000_000_000) + 'T';
  }

  switch (format) {
    case "DOLLARS":
      return `$${pValue.toLocaleString()}`;
    case "PERCENTAGES":
      return `${pValue}%`;
    default:
      return pValue.toLocaleString();
  }
};

export function IndexLineChart({ data, title, description, valueFormat }) {

  return (
      <Card className="bg-white shadow-lg border-border/50 hover:shadow-xl transition-shadow duration-300">
      <CardHeader>
        <CardTitle className="text-2xl font-bold">{description}</CardTitle>
        {/* <CardDescription className="text-base">{description}</CardDescription> */}
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={350}>
          <LineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" className="stroke-border/60" />
            <XAxis 
              dataKey="month" 
              className="text-muted-foreground"
              tick={{ fill: 'hsl(var(--muted-foreground))' }}
            />
            <YAxis 
              className="text-muted-foreground"
              tick={{ fill: 'hsl(var(--muted-foreground))' }}
              tickFormatter={(value) => formatValue(value, valueFormat)}
            />
            <Tooltip 
              contentStyle={{ 
                backgroundColor: 'hsl(var(--card))',
                border: '1px solid hsl(var(--border))',
                borderRadius: '0.5rem',
                color: 'hsl(var(--card-foreground))'
              }}
              formatter={(value: any) => formatValue(value, valueFormat)}
            />
            <Legend />
            <Line
              type="monotone"
              dataKey="target"
              stroke="hsl(var(--primary))"
              name="Target"
              strokeWidth={3}
              dot={{ r: 4 }}
              activeDot={{ r: 6 }}
              animationDuration={1000}
            />
          </LineChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}


// #endregion
export function TinyBarChart({ data, title = "Monthly Targets", description = "Performance metrics", valueFormat }) {
  return (
    <Card className="bg-white shadow-lg border-border/50 hover:shadow-xl transition-shadow duration-300">
      <CardHeader>
        <CardTitle className="text-2xl font-bold">{description}</CardTitle>
        {/* <CardDescription className="text-base">{description}</CardDescription> */}
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={400}>
          <BarChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" className="stroke-border/60" />
            <XAxis 
              dataKey="month" 
              className="text-muted-foreground"
              tick={{ fill: 'hsl(var(--muted-foreground))' }}
            />
            <YAxis 
              className="text-muted-foreground"
              tick={{ fill: 'hsl(var(--muted-foreground))' }}
              tickFormatter={(value) => formatValue(value, valueFormat)}
            />
            <Tooltip 
              contentStyle={{ 
                backgroundColor: 'hsl(var(--card))',
                border: '1px solid hsl(var(--border))',
                borderRadius: '0.5rem',
                color: 'hsl(var(--card-foreground))'
              }}
              formatter={(value: any) => formatValue(value, valueFormat)}
            />
            <Legend />
            <Bar
              dataKey="target"
              fill="hsl(var(--primary))"
              name="Target"
              radius={[8, 8, 0, 0]}
              barSize={40}
              animationDuration={1000}
            />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
